import { apiClient } from './api';

export type AnalyticsPeriod = 'today' | 'week' | 'month' | 'custom';

export interface DashboardMetrics {
  totalOrders: number;
  totalRevenue: number;
  avgOrderValue: number;
  activeUsers: number;
  activeRestaurants: number;
  activeCouriers: number;
  growthRate: number;
}

export interface TrendDataPoint {
  date: string;
  dateLabel: string;
  orders: number;
  revenue: number;
}

export interface KPIData {
  today: {
    orders: number;
    revenue: number;
    avgOrderValue: number;
    activeUsers: number;
  };
  yesterday: {
    orders: number;
    revenue: number;
    avgOrderValue: number;
    activeUsers: number;
  };
  lastWeek: {
    orders: number;
    revenue: number;
    avgOrderValue: number;
    activeUsers: number;
  };
}

export interface ReportQuery {
  type: 'financial' | 'operational' | 'customer' | 'restaurant' | 'courier';
  startDate: string;
  endDate: string;
  format?: 'csv' | 'json' | 'pdf' | 'excel';
}

export const analyticsService = {
  async getDashboardMetrics(
    period: AnalyticsPeriod = 'today',
    startDate?: string,
    endDate?: string,
  ): Promise<DashboardMetrics> {
    const response = await apiClient.get<DashboardMetrics>('/admin/analytics/dashboard', {
      params: {
        period,
        ...(startDate && { startDate }),
        ...(endDate && { endDate }),
      },
    });
    return response.data.data;
  },

  async getTrends(
    period: AnalyticsPeriod = 'today',
    startDate?: string,
    endDate?: string,
  ): Promise<TrendDataPoint[]> {
    const response = await apiClient.get<TrendDataPoint[]>('/admin/analytics/trends', {
      params: {
        period,
        ...(startDate && { startDate }),
        ...(endDate && { endDate }),
      },
    });
    return response.data.data;
  },

  async getKPIs(): Promise<KPIData> {
    const response = await apiClient.get<KPIData>('/admin/analytics/kpis');
    return response.data.data;
  },

  async generateReport(query: ReportQuery) {
    const response = await apiClient.get('/admin/analytics/reports', {
      params: query,
    });
    return response.data.data;
  },
};
